import React from 'react';
import ChevronIcon from 'components/icons/ChevronIcon';

const CSS = require('./NextButton.less');

const NextButton = ({ nextSlide }) => {
  const onClick = (e) => {
    nextSlide(e);
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className={CSS.CarouselButton}
    >
      <ChevronIcon
        width={7}
        height={12}
        direction="right"
      />
    </button>
  );
};

export default NextButton;
